import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('AddFilesDialogController', AddFilesDialogController);

    /** @ngInject */
    function AddFilesDialogController(
        $state,
        $stateParams,
        CompanyFactory,
        CompaniesFactory,
        ngDialog,
        toastr
    ) {
        var vm = this;

        CompanyFactory.readCompany().then(function (comp_id) {
            CompaniesFactory.readOneIssue(
                comp_id.data.organization.party_uuid,
                $stateParams.issue_id
            ).then(function (response) {
                vm.documentsFromBackend = response.data.attachments;
            });
        });

        vm.sendDataToBackend = function () {
            var data = {
                attachments: vm.files,
            };

            CompanyFactory.readCompany().then(function (comp_id) {
                CompaniesFactory.editIssue(
                    comp_id.data.organization.party_uuid,
                    $stateParams.issue_id,
                    data
                ).then(function () {
                    toastr.success('Zapisano zmiany');
                    ngDialog.close();
                    $state.reload('company_employee.issue_list.details');
                });
            });
        };
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/company_issue_list/details/add_files_dialog/add_files.controller.ts